import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
// slices
import mailReducer from './slices/mail'
import productReducer from './slices/product'
import calendarReducer from './slices/calendar'
import kanbanReducer from './slices/kanban'
import financeProductReducer from './slices/financeProduct'
import documentsReducer from './slices/creditSlices/documentsSlice'
import ticketsReducer from './slices/creditSlices/ticketsSlice';
import chatReducer from './slices/creditSlices/chatSlice'
import carteraReducer from './slices/creditSlices/carteraSlice';
import carteraReglasReducer from './slices/creditSlices/carteraReglasSlice';
import carteraMirrorReducer from './slices/creditSlices/carteraMirrorSlice';
import segmentacionReducer from './slices/creditSlices/segmentacionCarteraSlice';
import smsTemplateReducer from './slices/settings/smsTemplateSlice';
import liquidacionReglasReducer from './slices/settings/liquidacionReglasSlice';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
}

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
}

const rootReducer = combineReducers({
  mail: mailReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  financeProduct: financeProductReducer,
  documents: documentsReducer,
  chat: chatReducer,
  tickets: ticketsReducer,
  cartera: carteraReducer,
  carteraReglas: carteraReglasReducer,
  carteraMirror: carteraMirrorReducer,
  segmentacion: segmentacionReducer,
  templates: smsTemplateReducer,
  liquidacionReglas: liquidacionReglasReducer,
  product: persistReducer(productPersistConfig, productReducer),
});

export { rootPersistConfig, rootReducer }
